/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PotentialChangeOrdersControllerGetProjectStatusCountsQueryResponse, PotentialChangeOrdersControllerGetProjectStatusCountsQueryParams, PotentialChangeOrdersControllerGetProjectStatusCounts401, PotentialChangeOrdersControllerGetProjectStatusCounts403 } from "../../models/changeOrdersController/PotentialChangeOrdersControllerGetProjectStatusCounts";

function getPotentialChangeOrdersControllerGetProjectStatusCountsUrl() {
  const res = { method: 'GET', url: `/api/v1/project-status-counts` as const }  
  return res
}

/**
 * @summary Get potential change order counts for projects
 * {@link /api/v1/project-status-counts}
 */
export async function potentialChangeOrdersControllerGetProjectStatusCounts(params: PotentialChangeOrdersControllerGetProjectStatusCountsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PotentialChangeOrdersControllerGetProjectStatusCountsQueryResponse, ResponseErrorConfig<PotentialChangeOrdersControllerGetProjectStatusCounts401 | PotentialChangeOrdersControllerGetProjectStatusCounts403>, unknown>({ method : "GET", url : getPotentialChangeOrdersControllerGetProjectStatusCountsUrl().url.toString(), params, ... requestConfig })  
  return res.data
}